import BackArrow from '@/app/components/questionnaireV2/icons/back-arrow';

type LabsOrderStep = 1 | 2 | 3 | 4 | 5;

interface LabsOrderHeaderProps {
  currentStep: LabsOrderStep;
  onBack?: () => void;
  onClose?: () => void;
  showBackButton?: boolean;
  source?: 'risk_assessment' | 'traditional_flow';
}

const TOTAL_STEPS = 4;

export function LabsOrderHeader({
  currentStep,
  onBack,
  onClose,
  showBackButton = true,
  source
}: LabsOrderHeaderProps) {
  // Map step 5 to display as step 4 (step 4 was removed from the flow)
  const displayStep = currentStep === 5 ? 4 : currentStep;

  // In risk assessment context, always show as 7/7
  const isRiskAssessment = source === 'risk_assessment';

  return (
    <div className="questionnaire-header-container">
      {/* Video Background */}
      <video className="video-background" autoPlay loop muted playsInline>
        <source src="/videos/twilight.mp4" type="video/mp4" />
      </video>

      {/* Header Content */}
      <div className="questionnaire-header-content">
        <button
          onClick={onBack}
          className={`questionnaire-back-button ${!showBackButton || !onBack ? 'questionnaire-back-button--disabled' : ''}`}
          disabled={!showBackButton || !onBack}
          style={{
            opacity: showBackButton && onBack ? 1 : 0.5,
            cursor: showBackButton && onBack ? 'pointer' : 'not-allowed',
            pointerEvents: showBackButton && onBack ? 'auto' : 'none',
          }}
        >
          <BackArrow />
        </button>

        <div className="questionnaire-title-container">
          <h1 className="text-2xl">Catch Labs</h1>
        </div>

        <div className="questionnaire-counter-container" style={{ minWidth: '40px' }}>
          {onClose ? (
            <button
              onClick={onClose}
              className="text-white hover:text-gray-300 transition-colors p-2"
              aria-label="Close"
            >
              <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          ) : (
            <span className="questionnaire-category-counter">
              {isRiskAssessment ? '7/7' : `${displayStep}/${TOTAL_STEPS}`}
            </span>
          )}
        </div>
      </div>

      {/* Progress Bars */}
      <div className="questionnaire-progress-container">
        {Array.from({ length: TOTAL_STEPS }, (_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < displayStep;
          const isCurrent = stepNumber === displayStep;
          const isLastStep = displayStep === TOTAL_STEPS;

          // Last step shows full progress, other current steps show half
          if (isCurrent) {
            return (
              <div key={stepNumber} className="questionnaire-progress-bar">
                <div
                  className="questionnaire-progress-fill"
                  style={{ width: isLastStep ? '100%' : '50%' }}
                />
              </div>
            );
          }

          return (
            <div
              key={stepNumber}
              className={`questionnaire-progress-bar ${isCompleted ? 'bg-[var(--color-catch-avocado-400)]' : ''}`}
            />
          );
        })}
      </div>
    </div>
  );
}
